module.exports = __webpack_public_path__ + "static/img/case1.5ffeb2a6.png";